import React from 'react';
import { Show } from 'framework/show';
import { useCandidateId } from 'domain/recruiting/candidate/useCandidateId';
import { useCandidateService } from 'domain/shared/candidate';

const OfferTemplateWrapper = ({ children }: any) => {
  const { getById } = useCandidateService();
  const candidateId = useCandidateId();

  return <Show getDataMethod={() => getById(candidateId)}>{children}</Show>;
};

export default OfferTemplateWrapper;
